/**
 * DEBUG-log-upstream-message.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Todd L Smith <tsmith@safetyweb.org>
 */

import { Message } from "../general/message";
import { MessageTag } from "../message-tag";

// NOTE: we exclude ALL and OFF from the server's list.
export type LogLevel = "SEVERE" | "WARNING" | "INFO" | "CONFIG" | "FINE"
  | "FINER" | "FINEST";

/**
 * The client sends a {@link DebugLogUpstreamMessage} to log (arbitrary)
 * embedded content to the server log. This request is only available during
 * authenticated sessions (or disconnection therefrom).
 */
export class DebugLogUpstreamMessage extends Message
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.DBG_UP_LOG;
	public static tag : MessageTag = MessageTag.DBG_UP_LOG;

  public expectsReply () : boolean
  {
    return false;
  }

  /**
   * Construct a new {@link DebugLogUpstreamMessage}.
   *
   * @param level
   *        One of the allowed log levels.
   * @param message
   *        The object to log.
   */
  constructor (
    public level : LogLevel,
    public message : any,
    public useSecondaryLog : boolean = true)
  {
    super();
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/debug/DEBUG-log-upstream-message.ts